import { keyframes } from 'styled-components';
import ndsTokens from 'nicollet-tokens';

var fontSizes = function fontSizes(size) {
  switch (size) {
    case 'lg':
      return ndsTokens.font.size.text.large;

    case 'md':
      return ndsTokens.font.size.text.base;

    case 'sm':
      return ndsTokens.font.size.text.small;

    default:
      return ndsTokens.font.size.text.base;
  }
};

var borderRadiusSize = function borderRadiusSize() {
  return '4px';
};

var paddingSize = function paddingSize(size) {
  switch (size) {
    case 'lg':
      return ndsTokens.space.insetSquish['3x'];

    case 'md':
      return ndsTokens.space.insetSquish['2x'];

    case 'sm':
      return ndsTokens.space.insetSquish['1x'];

    default:
      return ndsTokens.space.insetSquish['2x'];
  }
};

var backgroundColor = function backgroundColor(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.default;

    case 'secondary':
      return ndsTokens.colors.interactive.secondary.default;

    case 'darkRed':
      return ndsTokens.colors.palette.red['33'];

    case 'darkGray':
      return ndsTokens.colors.background.darkest;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.default;
  }
};

var borderColor = function borderColor(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.default;

    case 'secondary':
      return ndsTokens.colors.border.interactive.secondary.default;

    case 'darkRed':
      return ndsTokens.colors.palette.red['33'];

    case 'darkGray':
      return ndsTokens.colors.background.darkest;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.default;
  }
};

var fontColor = function fontColor(variant) {
  switch (variant) {
    case 'primary':
    case 'darkRed':
    case 'darkGray':
      return ndsTokens.colors.text.onDark.primary;

    case 'secondary':
      return ndsTokens.colors.text.onLight.primary;

    case 'blank':
      return 'inherit';

    default:
      return ndsTokens.colors.text.onDark.primary;
  }
};

var hoverBackground = function hoverBackground(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.hover;

    case 'secondary':
      return ndsTokens.colors.interactive.secondary.hover;

    case 'darkGray':
      return ndsTokens.colors.palette.black;

    case 'darkRed':
      return ndsTokens.colors.palette.red.dark;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.hover;
  }
};

var hoverBorder = function hoverBorder(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.hover;

    case 'secondary':
      return ndsTokens.colors.border.interactive.secondary.hover;

    case 'darkGray':
      return ndsTokens.colors.palette.gray.darkest;

    case 'darkRed':
      return ndsTokens.colors.palette.red.darkest;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.hover;
  }
};

var hoverFontColor = function hoverFontColor(variant) {
  switch (variant) {
    case 'primary':
    case 'darkGray':
    case 'darkRed':
      return ndsTokens.colors.text.onDark.primary;

    case 'secondary':
      return ndsTokens.colors.text.onLight.primary;

    case 'blank':
      return 'inherit';

    default:
      return ndsTokens.colors.text.onDark.primary;
  }
};

var activeBackground = function activeBackground(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.active;

    case 'secondary':
    case 'darkRed':
    case 'darkGray':
      return ndsTokens.colors.interactive.secondary.active;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.active;
  }
};

var activeBorder = function activeBorder(variant) {
  switch (variant) {
    case 'primary':
      return ndsTokens.colors.interactive.primary.active;

    case 'secondary':
    case 'darkRed':
    case 'darkGray':
      return ndsTokens.colors.interactive.secondary.active;

    case 'blank':
      return 'transparent';

    default:
      return ndsTokens.colors.interactive.primary.active;
  }
};

var activeFontColor = function activeFontColor(variant) {
  switch (variant) {
    case 'primary':
    case 'darkRed':
    case 'secondary':
      return ndsTokens.colors.text.onDark.primary;

    case 'darkGray':
      return ndsTokens.colors.text.onDark.primary;

    default:
      return ndsTokens.colors.text.onDark.primary;
  }
};

var rippleKeyframe = keyframes(["0%{opacity:1;transform:scale(1);}100%{top:-7px;right:-7px;bottom:-7px;left:-7px;border-width:0;opacity:0;}"]);

export { fontSizes, borderRadiusSize, paddingSize, fontColor, backgroundColor, borderColor, hoverBackground, hoverBorder, hoverFontColor, activeFontColor, activeBackground, activeBorder, rippleKeyframe };
